// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "bb8590fa9ee1d90e37168b20e66ef9e0",
  base: "https://api.openweathermap.org/data/2.5/",
};
